<template>
  <div
    class="episode-item d-flex flew-row flex-nowrap justify-content-between align-items-center w-100 p-4 rounded"
  >
    <div class="d-flex justify-content-start align-items-center flex-grow-1">
      <span>
        <i class="fa fa-play-circle mr-3 c-brand-color fa-3x"></i>
      </span>
      <div class="d-flex flex-column justify-content-start align-items-start">
        <span class="small">{{
          $formatDate(episode.published_on, 'date-word')
        }}</span>
        <span class="h4 mb-0 c-charcoal">{{ episode.title }}</span>
      </div>
    </div>
    <div>
      <span>{{ duration }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EpisodeItem',
  props: {
    episode: {
      type: Object,
    },
  },
  computed: {
    audio() {
      return this.episode.media.media;
    },
    duration() {
      const d = this.audio.audio_length;
      if (d < 60) {
        return this.$tc('GENERAL.LABEL.SECOND_VARIANT', d, {
          count: d,
        });
      }
      const dM = Math.round(d / 60);
      return this.$tc('GENERAL.LABEL.MINUTE_VARIANT', dM, {
        count: dM,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.episode-item {
  &:hover {
    background: var(--brand-color-with-opacity-03, $light-gray);
  }
}
</style>
